"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _r10SourceLibrary = require("r10-source-library");
var _react = _interopRequireDefault(require("react"));
var _BroadbandCard = _interopRequireDefault(require("./BroadbandCard/BroadbandCard"));
var _RecommendationFooter = _interopRequireDefault(require("../RecommendationFooter"));
var _services = require("../../../services");
var _useRecommendationBroadbandTabs = require("../../../hooks/recommendation/useRecommendationBroadbandTabs");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const RecommendationBroadbandTabs = _ref => {
  let {
    broadbands,
    selectedBroadband
  } = _ref;
  const {
    onTabSwitch
  } = (0, _useRecommendationBroadbandTabs.useRecommendationBroadbandTabs)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Container, {
    elevation: true
  }, broadbands.length > 0 && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tabs, {
    tabs: {
      width: 'stretch'
    },
    onTabClick: onTabSwitch,
    externallySetTabId: selectedBroadband.productId
  }, broadbands.map((broadband, index) => {
    return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Tab, {
      key: broadband.productId,
      text: _services.locale.localeString(`Recommendation.${broadband.tier}`),
      id: broadband.productId
    }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
      spacingLevel: {
        top: 3
      }
    }, /*#__PURE__*/_react.default.createElement(_BroadbandCard.default, {
      broadband: broadband,
      broadbandIndex: index
    })), /*#__PURE__*/_react.default.createElement(_RecommendationFooter.default, null));
  })));
};
var _default = RecommendationBroadbandTabs;
exports.default = _default;